export default __webpack_public_path__ + "images/Tapas.2be0ad.jpg";